var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { UploadFileBase } from '@/components/ui/Form/UploadFile/UploadFileBase';
import { UploadFileText } from '@/components/ui/Form/UploadFile/UploadFileText';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
const defaultOnClickLink = () => __awaiter(void 0, void 0, void 0, function* () { });
/**
 * アップロードファイルを表示するためのボタンコンポーネント
 * @description IDを元に認証つきのファイルURL取得APIを叩いてファイル表示、のような挙動を想定。セキュアな取り扱いが必要なファイルであればこちらを使用したい
 * @param props
 * @constructor
 */
export const UploadFileButton = (props) => {
    const { className = '', fileName, hasUploadError = false, id = '', isDeletable, isUploading, onClickDelete, onClickLink: propOnClickLink = defaultOnClickLink, textSize, } = props;
    const unmountRef = useUnmountRef();
    // URL取得APIに連打させたくないので、取得中はボタンを無効化する
    const { callbackPromiseEvent: onClickFileLink, doing: isFetching } = usePromiseDoingCallback({
        promiseEvent: propOnClickLink,
        unmountRef,
    });
    const isNoLink = !id || hasUploadError || isUploading || isFetching;
    return (_jsx(UploadFileBase, Object.assign({ className: className, isDeletable: isDeletable, isUploading: isUploading, onClickDelete: onClickDelete }, { children: _jsx("button", Object.assign({ className: 'flex text-left', disabled: isNoLink, onClick: onClickFileLink, type: 'button', value: id === null ? undefined : id }, { children: _jsx(UploadFileText, { disabled: isNoLink, fileName: fileName, textSize: textSize }) })) })));
};
